import { render } from "./TextInputsPage.vue?vue&type=template&id=1d20af12&scoped=true"
import script from "./TextInputsPage.vue?vue&type=script&lang=js"
export * from "./TextInputsPage.vue?vue&type=script&lang=js"

import "./TextInputsPage.vue?vue&type=style&index=0&id=1d20af12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d20af12"]])

export default __exports__